
import React from 'react';


const ImpactStatsPage = () => {
	return (
		<div style={{width:"100%", height:"100%"}}>
			<h1>Under construction!</h1>
		</div>
	);
};

export default ImpactStatsPage;
